var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgThumbUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 21.9999V8.99993L13 3.04993C13.25 2.79993 13.5457 2.65393 13.887 2.61193C14.229 2.5706 14.5583 2.63326 14.875 2.79993C15.1917 2.9666 15.425 3.19993 15.575 3.49993C15.725 3.79993 15.7583 4.10826 15.675 4.42493L14.55 8.99993H21C21.5333 8.99993 22 9.19993 22.4 9.59993C22.8 9.99993 23 10.4666 23 10.9999V12.9999C23 13.1166 22.9833 13.2416 22.95 13.3749C22.9167 13.5083 22.8833 13.6333 22.85 13.7499L19.85 20.7999C19.7 21.1333 19.45 21.4166 19.1 21.6499C18.75 21.8833 18.3833 21.9999 18 21.9999H7ZM9 9.84993V19.9999H18L21 12.9999V10.9999H12L13.35 5.49993L9 9.84993ZM4 21.9999C3.45 21.9999 2.97933 21.8043 2.588 21.4129C2.196 21.0209 2 20.5499 2 19.9999V10.9999C2 10.4499 2.196 9.97893 2.588 9.58693C2.97933 9.1956 3.45 8.99993 4 8.99993H7V10.9999H4V19.9999H7V21.9999H4Z",
    fill: "#002677"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThumbUp);
export default __webpack_public_path__ + "static/media/thumb_up.24cb2e88c31756ac33dbdb977550f086.svg";
export { ForwardRef as ReactComponent };